/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
// material
import { Division, InContentMessage } from '@insticator/insticator-ui'; // iui-material
// pages
import EngagementProductsPage from "./engagementproducts/engagementproducts";
import ConfigurationPage from "./configuration/configuration";
import FullAdManagementPage from "./fulladmanagement/fulladmanagement";
import MobileAppPage from "./mobileapp/mobileapp";
import VideoAdManagementPage from "./videoadmangement/videoadmangement";
import SupplySidePlatformPage from "./supplysideplatform/supplysideplatform";
// utils
// thunks
// styles
import injectSheet from 'react-jss';
import styles from './monetization_styles';


/* ========== ~~~~~~~~~~ MONETIZATION V2 DIVISION ~~~~~~~~~~ ========== */

export default injectSheet(styles)((props) => {
    return(
        <Division name={`monetization`} klass={props.classes.monetization}>
            <Switch>
                {/*Routes to subdivisions*/}
                <Route exact path='/dashboard/monetization/engagementproducts'>
                    <EngagementProductsPage />
                </Route>
                <Route path='/dashboard/monetization/fulladmanagement'>
                    <FullAdManagementPage />
                </Route>
                <Route path='/dashboard/monetization/mobileapp'>
                    <MobileAppPage />
                </Route>
                <Route path='/dashboard/monetization/videoadmangement'>
                    <VideoAdManagementPage />
                </Route>
                <Route exact path='/dashboard/monetization/supplysideplatform'>
                    <SupplySidePlatformPage />
                </Route>
                <Route path='/dashboard/monetization/configuration'>
                    <ConfigurationPage />
                </Route>
                <Redirect to='/error/404'/>
            </Switch>
        </Division>
    )
});
